<mat-card class="container">
  <div class="mat-elevation-z4">
    <table mat-table [dataSource]="dataSource.data" class="full-width-table" matSort aria-label="Elements">

      <!-- Checkbox Column -->
      <!-- <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectedPrinter.toggle(row) : null"
          [checked]="selectedPrinter.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container> -->

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'printerTable.headingName' | translate}}</th>
      <td mat-cell *matCellDef="let row" (click)="openViewPrinterDialog(row)">{{row.name}}</td>
    </ng-container>

    <!-- deviceURI Column -->
    <ng-container matColumnDef="deviceURI">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'printerTable.headingConnection' | translate}}</th>
      <td mat-cell *matCellDef="let row" (click)="openViewPrinterDialog(row)">{{row.deviceURI}}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'printerTable.headingDescription' | translate}}</th>
      <td mat-cell *matCellDef="let row" (click)="openViewPrinterDialog(row)">{{row.description}}</td>
    </ng-container>

    <!-- location Column -->
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'printerTable.headingLocation' | translate}}</th>
      <td mat-cell *matCellDef="let row" (click)="openViewPrinterDialog(row)">{{row.location}}</td>
    </ng-container>

    <!-- state Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'printerTable.headingPrinterStatus' | translate}}</th>
      <td mat-cell *matCellDef="let row" (click)="openViewPrinterDialog(row)">{{row.state}}
        <!-- <button *ngIf="row.state == 'IDLE'" mat-icon-button><mat-icon>printer</mat-icon></button>
        <button *ngIf="row.state == 'STOPPED'" mat-icon-button><mat-icon>print_disabled</mat-icon></button> -->
      </td>
    </ng-container>

    <!-- isAcceptingJobs Column -->
    <ng-container matColumnDef="isAcceptingJobs">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'printerTable.headingQueueStatus' | translate}}</th>
      <td mat-cell *matCellDef="let row" (click)="openViewPrinterDialog(row)">
        @if (row.isAcceptingJobs == 'true') {
          <button mat-icon-button>
            <mat-icon>check_circle_outline</mat-icon>
          </button>
        }
        @if (row.isAcceptingJobs == 'false') {
          <button mat-icon-button>
            <mat-icon>cancel_outline</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <!-- actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{'printerTable.headingActions' | translate}}
      </th>
      <td mat-cell *matCellDef="let row">
        @if (this.activePrinterStates.includes(row.state)) {
          <button mat-icon-button matTooltip="{{'printerToolTips.pausePrinter' | translate}}"
            [matTooltipShowDelay]=1000 (click)="pausePrinter(row.name)">
            <mat-icon>stop</mat-icon>
          </button>
        }
        @if (row.state == 'STOPPED') {
          <button mat-icon-button matTooltip="{{'printerToolTips.resumePrinter' | translate}}" [matTooltipShowDelay]=1000
            (click)="resumePrinter(row.name)">
            <mat-icon>play_arrow</mat-icon>
          </button>
        }
        @if (row.isAcceptingJobs == 'true') {
          <button mat-icon-button matTooltip="{{'printerToolTips.disablePrinter' | translate}}"
            [matTooltipShowDelay]=1000 (click)="disablePrinter(row.name)">
            <mat-icon>print_disabled</mat-icon>
          </button>
        }
        @if (row.isAcceptingJobs == 'false') {
          <button matTooltip="{{'printerToolTips.enablePrinter' | translate}}" [matTooltipShowDelay]=1000
            mat-icon-button (click)="enablePrinter(row.name)">
            <mat-icon>printer</mat-icon>
          </button>
        }
        <button mat-icon-button matTooltip="{{'printerToolTips.openEditPrinterDialog' | translate}}" [matTooltipShowDelay]=1000
          (click)="openEditPrinterDialog(row)">
          <mat-icon>create</mat-icon>
        </button>
        <button mat-icon-button matTooltip="{{'printerToolTips.openDeletePrinterDialog' | translate}}" [matTooltipShowDelay]=1000
          (click)="openDeletePrinterDialog(row)">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button matTooltip="{{'printerToolTips.printTestPage' | translate}}" [matTooltipShowDelay]=1000
          (click)="printTestPage(row.name)">
          <mat-icon>text_snippet</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- <mat-paginator #paginator
  [length]="dataSource?.data.length"
  [pageIndex]="0"
  [pageSize]="50"
  [pageSizeOptions]="[25, 50, 100, 250]">
</mat-paginator> -->
@if (printerClass) {
  <mat-card-actions>
    <button mat-button (click)="openAddPrinterDialog()">
      <mat-icon>add</mat-icon>{{'printerTable.addPrinterButton' | translate}}
    </button>
  </mat-card-actions>
}
</div>
</mat-card>
